import useSWR from "swr";
import { getScoringRules } from "./service";
import { UseScoringRulesModel } from "./types";

const useScoringRules = (): UseScoringRulesModel => {
  const { data, error, isLoading, mutate } = useSWR(`/scoring/rules`, () =>
    getScoringRules(),
  );

  return {
    data: data?.results,
    isLoading,
    error,
    mutate,
  };
};

export default useScoringRules;
